// The frame of the new connection's pages: the trail back to the receptora, then the page. The
// journey's stylesheet is injected once, with this module.
import journeyStyles from './journey.css?inline';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

const journeyStyle = document.createElement('style');
journeyStyle.textContent = journeyStyles;
document.head.append(journeyStyle);

const TrailMark = (): JSX.Element => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true">
    <path d="M9 6l6 6-6 6" />
  </svg>
);

/** A journey page under the trail "Receptora › `place`". */
export const JourneyFrame = ({
  place,
  children,
}: {
  readonly place: string;
  readonly children: ReactNode;
}): JSX.Element => (
  <section className="admin-page receptora-page journey-page">
    <nav className="journey-trail" aria-label="Trilha">
      <Link to="/receptora">Receptora</Link>
      <TrailMark />
      <span aria-current="page">{place}</span>
    </nav>
    {children}
  </section>
);
